module.exports = __webpack_public_path__ + "static/img/content-1.e9ef1a7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cebc/content-1.jpeg
// module id = NseL
// module chunks = 0